import { render, staticRenderFns } from "./delete-account.view.html?vue&type=template&id=3d95b00a&"
import script from "./delete-account.vue?vue&type=script&lang=ts&"
export * from "./delete-account.vue?vue&type=script&lang=ts&"
import style0 from "./delete-account.view.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports